import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function PlatformAiBubbleMethodology() {
  return (
    <CustomerMethodologyPage
      title="Platform AI Assistant — overview"
      description="How the WeConsult Rx in-app AI assistant helps consultant pharmacists while protecting PHI."
      path="/trust/platform-ai-bubble-methodology"
    >
      <p>
        The in-app AI assistant helps consultant pharmacists find answers about
        clinical workflows, regulatory references, and platform features. It routes
        questions to the appropriate surface without storing raw message content.
      </p>
      <h2>What it does</h2>
      <ul>
        <li>Answers workflow and regulatory questions in context.</li>
        <li>Respects tenant and user boundaries — one user&apos;s session is never visible to another.</li>
        <li>Can be disabled by tenant owners for the entire organization.</li>
      </ul>
      <h2>What it does not do</h2>
      <ul>
        <li>Extract clinical facts (drugs, doses, labs) from charts — that remains deterministic.</li>
        <li>Replace pharmacist clinical judgment or serve as clinical decision support.</li>
        <li>Store plaintext user messages in the audit trail.</li>
      </ul>
    </CustomerMethodologyPage>
  );
}
